import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import FormInputField from '../FormInputField';
import Button, { buttonType } from '../../components/Button';
import Loader from '../Loader';
import { useLabels } from '../../hooks';
import { UserContext } from '../../contexts';
import styles from './LoginForm.module.scss';

const NewPasswordRequired = ({
    newPasswordRequiredData,
}) => {
    const [ showLoader, setShowLoader ] = useState(false);
    const [ error, setError ] = useState();
    const { getLabel, getCognitoApiError } = useLabels();
    const { completeNewPasswordChallenge } = useContext(UserContext);
    const isActive = useRef(false);
    const newPasswordRef = useRef();
    const confirmNewPasswordRef = useRef();

    useEffect(() => {
        isActive.current = true;
        return () => { isActive.current = false; };
    }, []);

    const confirmPasswordValidation = useCallback((password) => {
        return password === newPasswordRef.current.getValue()
            ? ''
            : getLabel('login_form_confirm_new_password_match_error');
    }, [getLabel]);

    const onSubmit = useCallback((event) => {
        event.preventDefault();
        let focusField = null;

        if (!newPasswordRef.current.validation()) {
            focusField = focusField || newPasswordRef.current;
        }
        if (!confirmNewPasswordRef.current.validation()) {
            focusField = focusField || confirmNewPasswordRef.current;
        }
        if (focusField) {
            focusField.focus();
            return;
        }

        setError(null);
        setShowLoader(true);

        const newPassword = newPasswordRef.current.getValue();

        completeNewPasswordChallenge(
            newPasswordRequiredData.cognitoUser,
            newPassword,
            newPasswordRequiredData.userAttributes
        ).catch(err => {
            if (isActive.current) setError(err);
        }).finally(() => {
            if (isActive.current) setShowLoader(false);
        });
    }, [completeNewPasswordChallenge, newPasswordRequiredData.cognitoUser, newPasswordRequiredData.userAttributes]);

    return <>
        <div className={styles.login}>
            <div className={styles.content}>
                <div>
                    <div className={styles.title}>{getLabel('login_form_new_password_required_password_title')}</div>
                    <div className={styles.text}>{getLabel('login_form_new_password_required_password_text')}</div>
                    <form className={styles.fields} onSubmit={onSubmit}>
                        <FormInputField
                            label={getLabel('login_form_confirm_new_password_field')}
                            placeholder={getLabel('login_form_confirm_new_password_field_placeholder')}
                            ref={newPasswordRef}
                            passwordValidation={true}
                            type="password"
                            heContentDirection={'ltr'}
                            hePlaceholderDirection={'rtl'}
                        />
                        <FormInputField
                            label={getLabel('login_form_confirm_again_new_password_field')}
                            placeholder={getLabel('login_form_confirm_again_new_password_field_placeholder')}
                            ref={confirmNewPasswordRef}
                            validationPattern={confirmPasswordValidation}
                            type="password"
                            heContentDirection={'ltr'}
                            hePlaceholderDirection={'rtl'}
                        />
                        <button hidden={true}></button>
                    </form>
                </div>
                <div className={styles.buttons}>
                    <div>
                        <div className={styles.error} dangerouslySetInnerHTML={{ __html: getCognitoApiError(error)}} />
                        <Button type={buttonType.premium} className={styles.main_button} onClick={onSubmit}>
                            {getLabel('login_form_confirm_change_password_button')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
        {showLoader && <Loader />}
    </>;
};

export default NewPasswordRequired;
